import { render } from "./HomeApp.vue?vue&type=template&id=4d55a99d&scoped=true"
import script from "./HomeApp.vue?vue&type=script&lang=js"
export * from "./HomeApp.vue?vue&type=script&lang=js"

import "./HomeApp.vue?vue&type=style&index=0&id=4d55a99d&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend_ahdeco/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d55a99d"]])

export default __exports__